import actionTypes from './types';

export const showSnackBar = (payload: any) => ({
  type: actionTypes.SHOW_SNACKBAR,
  payload,
});

export const hideSnackBar = (payload: any) => ({
  type: actionTypes.HIDE_SNACKBAR,
  payload,
});
